import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class ResumoEventoDiaService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'resumo-evento-dia');
  }

  filter(startDate = null, endDate = null, estacaoList = [] , grupoList = [], clienteList = [], sensorList = [], plu = null, flu = null, integradorList= [], coletorList = [], tipoEventoList = [], includeStatus = false, modoMapaExterno = false): Observable<any> {
    const url = this.buildFilterUrl('groupby/estacao/legacy-light', startDate, endDate, estacaoList, grupoList, clienteList, sensorList, plu, flu, integradorList, coletorList, tipoEventoList, false, includeStatus, modoMapaExterno);
    return this.http.get(url);
  }

  filterMap(startDate = null, endDate = null, estacaoList = [] , grupoList = [], clienteList = [], sensorList = [], plu = null, flu = null, integradorList= [], coletorList = [], modoMapaExterno = false): Observable<any> {
    const url = this.buildFilterUrl('groupby/estacao/map', startDate, endDate, estacaoList, grupoList, clienteList, sensorList, plu, flu, integradorList, coletorList, [], false, false, modoMapaExterno);
    return this.http.get(url);
  }

  statePolygons(): Observable<any> {
    const url = `${this.url_base}/${this.prefixo}/map/state-polygons`;
    return this.http.get(url);
  }

  municipalityPolygons(uf: string): Observable<any> {
    const url = `${this.url_base}/${this.prefixo}/map/municipality-polygons/${encodeURIComponent(uf)}`;
    return this.http.get(url).pipe(timeout(120000));
  }

  mapDialog(estacaoId: number, dataEvento: string): Observable<any> {
    const url = `${this.url_base}/${this.prefixo}/estacao/${estacaoId}/map-dialog?dataEvento=${dataEvento}`;
    return this.http.get(url);
  }

  ocorrenciasIrregulares(estacaoId: number, dataEvento: string): Observable<any> {
    const url = `${this.url_base}/${this.prefixo}/estacao/${estacaoId}/ocorrencias-irregulares?dataEvento=${dataEvento}`;
    return this.http.get(url);
  }

  /**
   * Versão otimizada (endpoint light) para a tela /controle/resumo-eventos.
   * Se apenasInconformidade = true, retorna apenas eventos em inconformidade (situacao "1" no api/estacoes/status).
   */
  filterLight(startDate = null, endDate = null, estacaoList = [] , grupoList = [], clienteList = [], sensorList = [], plu = null, flu = null, integradorList= [], coletorList = [], tipoEventoList = [], apenasInconformidade = false): Observable<any> {
    const url = this.buildFilterUrl('groupby/estacao/light', startDate, endDate, estacaoList, grupoList, clienteList, sensorList, plu, flu, integradorList, coletorList, tipoEventoList, apenasInconformidade);
    return this.http.get(url);
  }

  filterMonitoramentoGridLight(startDate = null, endDate = null, estacaoList = [] , grupoList = [], clienteList = [], sensorList = [], plu = null, flu = null, integradorList= [], coletorList = [], tipoEventoList = [], apenasInconformidade = false): Observable<any> {
    const url = this.buildFilterUrl('monitoramento/grid-resumo', startDate, endDate, estacaoList, grupoList, clienteList, sensorList, plu, flu, integradorList, coletorList, tipoEventoList, apenasInconformidade);
    return this.http.get(url);
  }

  filterRelatorioAnalitico(startDate = null, endDate = null, estacaoList = [] , grupoList = [], clienteList = [], sensorList = [], plu = null, flu = null, integradorList= [], coletorList = [], tipoEventoList = [], somenteSituacaoEventoUm = true): Observable<any> {
    let url = this.buildFilterUrl('relatorio-analitico', startDate, endDate, estacaoList, grupoList, clienteList, sensorList, plu, flu, integradorList, coletorList, tipoEventoList);
    if (somenteSituacaoEventoUm) {
      url += '&somente_situacao_evento_1=1';
    }
    return this.http.get(url);
  }

  private buildFilterUrl(
    path: string,
    startDate: string | null,
    endDate: string | null,
    estacaoList: any[],
    grupoList: any[],
    clienteList: any[],
    sensorList: any[],
    plu: string | null,
    flu: string | null,
    integradorList: any[],
    coletorList: any[],
    tipoEventoList: any[],
    apenasInconformidade = false,
    includeStatus = false,
    modoMapaExterno = false
  ): string {
    let url = `${this.url_base}/${this.prefixo}/${path}`;
    if (startDate !== null) {
      url += `?dataEventoStart=${startDate}`;
    }
    if (endDate !== null) {
      url += `&dataEventoEnd=${endDate}`;
    }
    if (estacaoList.length > 0) {
      estacaoList.forEach(element => {
        url += `&estacaoList[]=${element}`;
      });
    }
    if (grupoList.length > 0) {
      grupoList.forEach(element => {
        url += `&grupoList[]=${element}`;
      });
    }
    if (clienteList.length > 0) {
      clienteList.forEach(element => {
        url += `&clienteList[]=${element}`;
      });
    }
    if (sensorList.length > 0) {
      sensorList.forEach(element => {
        url += `&sensorList[]=${element}`;
      });
    }
    if (plu !== null) {
      url += `&plu=${plu}`;
    }
    if (flu !== null) {
      url += `&flu=${flu}`;
    }
    if (integradorList.length > 0) {
      integradorList.forEach(element => {
        url += `&integradorList[]=${element}`;
      });
    }
    if (coletorList.length > 0) {
      coletorList.forEach(element => {
        url += `&coletorList[]=${element}`;
      });
    }
    if (tipoEventoList.length > 0) {
      tipoEventoList.forEach(element => {
        url += `&tipoEventoList[]=${element}`;
      });
    }
    if (apenasInconformidade) {
      url += '&apenas_inconformidade=1';
    }
    if (includeStatus) {
      url += '&include_status=1';
    }
    if (modoMapaExterno) {
      url += '&modo_mapa_externo=1';
    }
    return url;
  }
  
  remake(params): Observable<any> {
    let url = `${this.url_base}/${this.prefixo}/remake`;

    return this.http.post(url, params);
  }

  /**
   * Marca o resumo evento dia como ativo ou inativo (excluir).
   * PATCH resumo-evento-dia/{id}/ativo
   */
  setAtivo(id: number, ativo: boolean): Observable<any> {
    const url = `${this.url_base}/${this.prefixo}/${id}/ativo`;
    return this.http.patch(url, { ativo });
  }
}
